import { useApi, Status } from "./useApi";
import { waLink } from "@/lib/api";

export const CalidadView = () => {
  const { data, error } = useApi("/calidad");
  if (!data) return <Status data={data} error={error} />;
  return (
    <div className="panel" data-testid="calidad-view">
      <h4>Notas de calidad de datos ({data.length})</h4>
      {data.length === 0 && <p className="note">No hay observaciones cargadas.</p>}
      {data.map((c) => (
        <p key={c.id} data-testid={`calidad-item-${c.id}`}><b>{c.archivo}</b><br /><span className="note">{c.nota}</span></p>
      ))}
    </div>
  );
};

const fmt = (iso) => { try { return new Date(iso).toLocaleString("es-CO"); } catch (e) { return iso; } };

const resp = (d) => Object.keys(d || {}).filter((k) => k !== "quien" && k !== "ok" && d[k] !== "").map((k) => `${k}: ${d[k]}`).join(" · ");

export const ParticipacionesView = () => {
  const { data, error } = useApi("/participaciones");
  if (!data) return <Status data={data} error={error} />;
  return (
    <div className="panel" data-testid="participaciones-view">
      <h4>Participaciones en actividades y pasaporte ({data.length})</h4>
      {data.length === 0 ? <p className="note">Sin participaciones todavía.</p> : (
        <div className="wrapx">
          <table className="tbl" data-testid="participaciones-table">
            <thead><tr><th>Fecha</th><th>Actividad</th><th>Quién</th><th>Grupo / edad</th><th>Respuestas</th></tr></thead>
            <tbody>{data.map((p) => (
              <tr key={p.id} data-testid={`participacion-row-${p.id}`}><td style={{ whiteSpace: "nowrap" }}>{p.fecha}</td><td>{p.nombre}</td><td>{p.datos?.quien || "Anónimo"}</td><td>{[p.datos?.grupo, p.datos?.edad].filter(Boolean).join(" · ")}</td><td>{resp(p.datos)}</td></tr>
            ))}</tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export const AuditoriaView = () => {
  const { data, error } = useApi("/auditoria");
  if (!data) return <Status data={data} error={error} />;
  return (
    <div className="panel" data-testid="auditoria-view">
      <h4>Auditoría de registros (últimos {data.length} cambios)</h4>
      {data.length === 0 && <p className="note">Aún no hay cambios.</p>}
      <div className="wrapx">
        <table className="tbl" data-testid="auditoria-table">
          <thead><tr><th>Fecha</th><th>Usuario</th><th>Acción</th><th>Registro</th><th>Campos</th></tr></thead>
          <tbody>{data.map((a) => (
            <tr key={a.id}><td style={{ whiteSpace: "nowrap" }}>{fmt(a.fecha)}</td><td>{a.usuario}</td><td>{a.accion}</td><td>{a.titulo}</td><td>{a.accion === "editar" ? Object.keys(a.cambios || {}).join(", ") : ""}</td></tr>
          ))}</tbody>
        </table>
      </div>
    </div>
  );
};

export const MensajesView = () => {
  const { data, error } = useApi("/mensajes");
  if (!data) return <Status data={data} error={error} />;
  return (
    <div className="panel" data-testid="mensajes-view">
      <h4>Mensajes del formulario de contacto ({data.length})</h4>
      <p className="note">Se guardan cuando alguien usa “Enviar por WhatsApp” en la sección Hablemos.</p>
      {data.length === 0 && <p className="note">Aún no hay mensajes.</p>}
      <div className="wrapx">
        <table className="tbl" data-testid="mensajes-table">
          <thead><tr><th>Fecha</th><th>Nombre</th><th>Institución</th><th>Soy</th><th>Teléfono</th><th>Mensaje</th></tr></thead>
          <tbody>
            {data.map((m) => (
              <tr key={m.id} data-testid={`mensaje-row-${m.id}`}>
                <td style={{ whiteSpace: "nowrap" }}>{fmt(m.created_at)}</td><td>{m.nombre}</td><td>{m.institucion}</td><td>{m.tipo}</td>
                <td>{m.telefono && <a href={waLink(m.telefono, `Hola ${m.nombre}, te escribimos de la Fundación Once y Once.`)} target="_blank" rel="noopener noreferrer" style={{ color: "var(--sol-l)" }}>{m.telefono}</a>}</td>
                <td style={{ whiteSpace: "pre-wrap" }}>{m.mensaje}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
